var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rolesList"},[_c('b-row',[_c('b-col',[_c('roles-add',{on:{"refreshList":_vm.refrescarLista}})],1)],1),_c('spacer-card'),_c('b-row',[_c('b-col',[_c('roles-edit',{ref:"editarroles"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }